import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-main-navbar",
  templateUrl: "./main-navbar.component.html",
  styleUrls: ["./main-navbar.component.css"],
})
export class MainNavbarComponent implements OnInit {
  homepageLink = "/";
  ourteamLink = "/our-team";
  companyPage = "/company";
  contactPage = "/contact";
  blogPage = "/blog-page";
  listings_page = "/all-listings";
  residential = "/residential";
  commercial = "/commercial";
  constructor() {}

  ngOnInit(): void {}
}
